import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";

const workingCuttingMapRestUrl = ordersServicesPath + '/organizations/working-cutting-maps'

export default class WorkingCuttingMapService {

    static async getAll() {
        return axios.get(workingCuttingMapRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCalculation() {
        return axios.get(workingCuttingMapRestUrl + '/calculation', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllArchive() {
        return axios.get(workingCuttingMapRestUrl + '/archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCalculationArchive() {
        return axios.get(workingCuttingMapRestUrl + '/calculation-archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id, drawEdge) {
        let url = workingCuttingMapRestUrl + '/' + id;
        if (drawEdge != null) {
            url += '?drawEdge=' + drawEdge;
        }
        return axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(id, supplierId, data) {
        return axios.put(workingCuttingMapRestUrl + '/' + id + '?supplierId=' + supplierId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async recreate(id) {
        return axios.patch(workingCuttingMapRestUrl + '/' + id + '/recreate', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getState(id) {
        return axios.get(workingCuttingMapRestUrl + '/' + id + '/get-working-cutting-map-state', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(workingCuttingMapRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createByIdsOptimization(ids, isCalculation) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(workingCuttingMapRestUrl + '/create-by-ids-optimization' + "?isCalculation=" + isCalculation, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async approveCuttingMap(workingCuttingMapId) {
        return await axios.post(workingCuttingMapRestUrl + '/' + workingCuttingMapId + '/approve', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async cancelCuttingMap(workingCuttingMapId) {
        return await axios.post(workingCuttingMapRestUrl + '/' + workingCuttingMapId + '/cancel', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async cancelReserve(workingCuttingMapId) {
        return await axios.post(workingCuttingMapRestUrl + '/' + workingCuttingMapId + '/cancel-reserve', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async cut(workingCuttingMapId, detailReserve, recalculationCost, alternativeServer) {
        let url = workingCuttingMapRestUrl + '/cut?workingCuttingMapId=' + workingCuttingMapId;
        if (detailReserve != null) {
            url += '&detailReserve=' + detailReserve;
        }
        if (recalculationCost != null) {
            url += '&recalculationCost=' + recalculationCost;
        }
        if (alternativeServer != null) {
            url += '&alternativeServer=' + alternativeServer;
        }
        return await axios.post(url, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setForCutting(currentIdRow) {
        return await axios.post(workingCuttingMapRestUrl + '/' + currentIdRow + '/set-for-cutting', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setForCuttingByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(workingCuttingMapRestUrl + '/set-for-cutting', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setStartCutting(currentIdRow) {
        return await axios.post(workingCuttingMapRestUrl + '/' + currentIdRow + '/set-start-cutting', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setStartCuttingByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(workingCuttingMapRestUrl + '/set-start-cutting', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async raiseCuttingPriority(currentIdRow) {
        return await axios.post(workingCuttingMapRestUrl + '/' + currentIdRow + '/raise-cutting-priority', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async lowerCuttingPriority(currentIdRow) {
        return await axios.post(workingCuttingMapRestUrl + '/' + currentIdRow + '/lower-cutting-priority', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllForCuttingWithOptimization() {
        return axios.get(workingCuttingMapRestUrl + '/all-for-cutting-with-optimization', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setFinishCut(id, performJob, body) {
        return await axios.put(
            workingCuttingMapRestUrl + '/' + id + '/finish-cut?performJob=' + performJob,
            JSON.stringify(body),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async sendToArchive(id) {
        return await axios.patch(workingCuttingMapRestUrl + '/' + id + '/send-to-archive', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async approveByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(workingCuttingMapRestUrl + '/approve', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendToArchiveByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(workingCuttingMapRestUrl + '/send-to-archive', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnForRevision(id) {
        return await axios.patch(workingCuttingMapRestUrl + '/' + id + '/return-for-revision', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnForStartCutting(id) {
        return await axios.patch(workingCuttingMapRestUrl + '/' + id + '/return-for-start-cutting', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnForRevisionByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(workingCuttingMapRestUrl + '/return-for-revision', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async cutByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(workingCuttingMapRestUrl + '/cut-by-ids', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setNote(id, note) {
        return await axios.patch(workingCuttingMapRestUrl + '/' + id + '/set-note', note ?? '', {
            headers: {
                'Content-Type': 'text/plain;charset=UTF-8'
            }
        });
    }
}